import {
  TObjectShareResponse,
  TObjectShareUpdateRequest,
} from "../../../../services/api/instances/storageApi/types/service_types";

export const flattenPermissionsForUpdate = (
  permissions: TObjectShareResponse[],
): { id: number; putObject: TObjectShareUpdateRequest }[] =>
  permissions.flatMap(({ permission_pairs, id, write, active, valid_till }) => {
    if (!permission_pairs) return [];
    const putObject: TObjectShareUpdateRequest = { write, active, valid_till };

    if (permission_pairs.length > 0) {
      return permission_pairs
        .filter((pair) => pair.origin === "update")
        .map((pair) => ({ id: pair.id, putObject }));
    }

    return [{ id: id as number, putObject }];
  });
